import React from 'react'

function Testimonial ({ content, image, name, company }) {
  // content in WP should not include quotes
  return (
    <div className='testimonial center relative'>
      <blockquote
        className='testimonial__quote text-para mb3'
        dangerouslySetInnerHTML={{ __html: content }}
      />
      <div className='testimonial__media mb2 xs-hide md-hide overflow-hidden'>
        <div
          className='testimonial__media__img'
          style={{ backgroundImage: `url(${image})` }}
        />
      </div>
      <div className='testimonial__content text-para'>
        <div className='strong text-color'>{name}</div>
        <div>{company}</div>
      </div>
    </div>
  )
}

export default Testimonial



// WEBPACK FOOTER //
// ./frontend/scripts/react/components/Testimonial.js